import React, { useState } from 'react'
import DateInput from '../components/input/Date'
import TopBar from '../components/menu/TopBar'
import { useDispatch, useSelector } from 'react-redux';
import validateInput from '../utilities/validations/validateInput';
import { language } from '../stores/slices/languageSlice';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'
import Input from '../components/input/Input';
import ReactPaginate from 'react-paginate';
// import cprLogo from "../assets/images/cprLogo5.png";
import cprLogo from "../assets/images/totalassist.png";
import newLogo from "../assets/images/newLogo.png";
import fafLogo from "../assets/images/logo1.png";
import style from "../components/login/login.module.css";
import { getCaseReport } from '../stores/slices/caseManagement/caseReportsSlice';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
import Loader from '../components/menu/Loader';

function Reports() {
    const applicationLists = useSelector((state) => state.applicationsSlice);
    const [appCount, setAppCount] = useState({
        total: 0,
        closed: 0,
        pending: 0,
        denied: 0,
        expired: 0,
        approved: 0
    })
    const [reportsData, setReportsData] = useState({
        startDate: { value: "", isValid: true },
        endDate: { value: "", isValid: true },
        program: { value: "", isValid: true },
        search: { value: "", isValid: true }
    })
    const [isDataAvailable, setIsDataAvailable] = useState(false)
    const [reportsValue, setReportsValue] = useState([])
    const [initialValue, setInitialValue] = useState([])

    const dispatch = useDispatch()

    const errorMessage = useSelector(language).errorMessage;
    const caseLists = useSelector((state) => state.caseListSlice.caseList)
    const einNumber = useSelector((state) => state.loginSlice.value.EIN)

    const loader = useSelector((state) => state.caseReportsSlice.loader)

    const [posts, setPosts] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [postsPerPage] = useState(5);

    const offset = (currentPage * postsPerPage) % reportsValue.length;
    const currentPosts = posts.slice(offset, offset + postsPerPage);

    const handlePageClick = ({ selected }) => {
        setCurrentPage(selected);
    };

    const inputOnChange = (e, fieldvalidation) => {
        setIsDataAvailable(false)
        let inputValue = e.target.value;
        let name = e.target.name;
        let inputValidate = validateInput(inputValue, fieldvalidation);
        if (name == "startDate") {
            setReportsData((prevState) => ({
                ...prevState,
                endDate: {
                    value: prevState.endDate.value,
                    isValid: true,
                },
                [name]: {
                    value: inputValidate.value,
                    isValid: inputValidate.isValid,
                },
            }))
        }

        setReportsData((prevState) => ({
            ...prevState,
            [name]: {
                value: inputValidate.value,
                isValid: inputValidate.isValid,
            },
        }))
    }

    const getReports = async () => {
        let isValidData = false
        setReportsData((prevState) => ({
            ...prevState,
            search: {
                value: "",
                isValid: true,
            },
        }))
        isValidData = reportsData.startDate.value != "" && reportsData.startDate.isValid && reportsData.endDate.value != "" && reportsData.endDate.isValid && reportsData.program.value != "" && reportsData.program.isValid && reportsData.startDate.value <= reportsData.endDate.value

        if (isValidData) {
            setIsDataAvailable(true)
            setCurrentPage(0)
            setReportsValue([])
            const startDate = moment(reportsData.startDate.value).startOf('day');
            const endDate = moment(reportsData.endDate.value).endOf('day');

            let totalApplications = 0
            let closedApplications = 0
            let pending = 0
            let denied = 0
            let expired = 0
            let approved = 0

            let totalCases = 0
            let attempted = 0
            let newCases = 0
            let inProgress = 0
            let closedCases = 0

            let arr = []

            if (reportsData.program.value == "FAF") {
                applicationLists?.valueFAF?.map((data) => {
                    if (moment(data.pxCreateDateTime).isBetween(startDate, endDate, undefined, '[]')) {
                        arr.push(data)
                        totalApplications = totalApplications + 1
                        if (data.PortalAppStatus == "Closed") {
                            closedApplications = closedApplications + 1
                        } else if (data.PortalAppStatus == "Pending") {
                            pending = pending + 1
                        } else if (data.PortalAppStatus == "Denied") {
                            denied = denied + 1
                        } else if (data.PortalAppStatus == "Expired") {
                            expired = expired + 1
                        } else if (data.PortalAppStatus == "Approved") {
                            approved = approved + 1
                        }
                    }
                })
                setAppCount({ totalApplications, closedApplications, pending, denied, expired, approved, totalCases, attempted, newCases, inProgress, closedCases })
                setReportsValue(arr)
                setInitialValue(arr)
                setPosts(arr)
            } else if (reportsData.program.value == "CPR") {
                applicationLists?.valueCPR?.map((data) => {
                    if (moment(data.pxCreateDateTime).isBetween(startDate, endDate, undefined, '[]')) {
                        arr.push(data)
                        totalApplications = totalApplications + 1
                        if (data.PortalAppStatus == "Closed") {
                            closedApplications = closedApplications + 1
                        } else if (data.PortalAppStatus == "Pending") {
                            pending = pending + 1
                        } else if (data.PortalAppStatus == "Denied") {
                            denied = denied + 1
                        } else if (data.PortalAppStatus == "Expired") {
                            expired = expired + 1
                        } else if (data.PortalAppStatus == "Approved") {
                            approved = approved + 1
                        }
                    }
                })
                setAppCount({ totalApplications, closedApplications, pending, denied, expired, approved, totalCases, attempted, newCases, inProgress, closedCases })
                setReportsValue(arr)
                setInitialValue(arr)
                setPosts(arr)
            } else if (reportsData.program.value == "CASE") {
                const caseReports = await dispatch(getCaseReport({ einnumber: einNumber, startdate: reportsData.startDate.value, enddate: reportsData.endDate.value }))
                caseReports?.payload?.data?.map((data) => {
                    // moment(data.pxCreateDateTime).tz('America/New_York').format('LL')
                    const createdDate = new Date(data.createddate)
                    const approvedDate = new Date(data.AppApprovalDateTime)
                    if (moment(data.createddate).isBetween(startDate, endDate, undefined, '[]')) {
                        arr.push({
                            applicationID: data.casenumber,
                            caseNumber: data.casenumber,
                            pxCreateDateTime: data.createddate,
                            PatientFullName: data.patientname,
                            pointOfContactName: data.pointofcontactname,
                            PortalAppStatus: data.status,
                            subStatus: data.substatus,
                            program: "CASE"
                        })
                        totalCases = totalCases + 1
                        if (data.status == "Attempted") {
                            attempted = attempted + 1
                        } else if (data.status == "Closed") {
                            closedCases = closedCases + 1
                        } else if (data.status == "New") {
                            newCases = newCases + 1
                        } else if (data.status == "In Progress" || data.status == "InProgress") {
                            inProgress = inProgress + 1
                        } else if (data.status == "Approved") {
                            approved = approved + 1
                        }
                    }
                })

                setAppCount({ totalApplications, closedApplications, pending, denied, expired, approved, totalCases, attempted, newCases, inProgress, closedCases })
                setReportsValue(arr)
                setInitialValue(arr)
                setPosts(arr)
            } else {

                function toTitleCase(str) {
                    return str
                        .toLowerCase() // Make all letters lowercase first
                        .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
                }

                const combinedReport = []
                const caseReports = await dispatch(getCaseReport({ einnumber: einNumber, startdate: reportsData.startDate.value, enddate: reportsData.endDate.value }))
                applicationLists?.valueFAF?.map((data) => {
                    if (moment(data.pxCreateDateTime).isBetween(startDate, endDate, undefined, '[]')) {
                        combinedReport.push({ name: toTitleCase(data.PatientFullName), type: "Application", program: "FAF", id: data.ApplicationID, createdDate: moment(data.pxCreateDateTime).format("M/D/YYYY"), status: data.PortalAppStatus })
                        totalApplications = totalApplications + 1
                        if (data.PortalAppStatus == "Closed") {
                            closedApplications = closedApplications + 1
                        } else if (data.PortalAppStatus == "Pending") {
                            pending = pending + 1
                        } else if (data.PortalAppStatus == "Denied") {
                            denied = denied + 1
                        } else if (data.PortalAppStatus == "Expired") {
                            expired = expired + 1
                        } else if (data.PortalAppStatus == "Approved") {
                            approved = approved + 1
                        }
                    }
                })
                applicationLists?.valueCPR?.map((data) => {
                    if (moment(data.pxCreateDateTime).isBetween(startDate, endDate, undefined, '[]')) {
                        combinedReport.push({ name: toTitleCase(data.PatientFullName), type: "Application", program: "CPR", id: data.ApplicationID, createdDate: moment(data.pxCreateDateTime).format("M/D/YYYY"), status: data.PortalAppStatus })
                        totalApplications = totalApplications + 1
                        if (data.PortalAppStatus == "Closed") {
                            closedApplications = closedApplications + 1
                        } else if (data.PortalAppStatus == "Pending") {
                            pending = pending + 1
                        } else if (data.PortalAppStatus == "Denied") {
                            denied = denied + 1
                        } else if (data.PortalAppStatus == "Expired") {
                            expired = expired + 1
                        } else if (data.PortalAppStatus == "Approved") {
                            approved = approved + 1
                        }
                    }
                })

                caseReports?.payload?.data?.map((data) => {
                    if (moment(data.createddate).isBetween(startDate, endDate, undefined, '[]')) {
                        combinedReport.push({ name: toTitleCase(data.patientname), type: "Case", program: "CM", id: data.casenumber, createdDate: moment(data.createddate).format("M/D/YYYY"), status: data.status })
                        totalCases = totalCases + 1
                        if (data.status == "Attempted") {
                            attempted = attempted + 1
                        } else if (data.status == "Closed") {
                            closedCases = closedCases + 1
                        } else if (data.status == "New") {
                            newCases = newCases + 1
                        } else if (data.status == "In Progress" || data.status == "InProgress") {
                            inProgress = inProgress + 1
                        } else if (data.status == "Approved") {
                            approved = approved + 1
                        }
                    }
                })

                const grouped = {};

                combinedReport.forEach(item => {
                    if (!grouped[item.name]) {
                        grouped[item.name] = { name: item.name, records: [] };
                    }
                    grouped[item.name].records.push({
                        type: item.type,
                        program: item.program,
                        id: item.id,
                        createdDate: item.createdDate,
                        status: item.status
                    });
                });

                setAppCount({ totalApplications, closedApplications, pending, denied, expired, approved, totalCases, attempted, newCases, inProgress, closedCases })
                setReportsValue(Object.values(grouped))
                setInitialValue(Object.values(grouped))
                setPosts(Object.values(grouped))
            }
        } else {
            setIsDataAvailable(false)
            let endDateValid = true
            const today = new Date()
            if (new Date(reportsData.startDate.value) <= today && reportsData.startDate.value != "" && !reportsData.startDate.isValid) {
                toast.error("Selected date should be within the last two years")
            } else if (new Date(reportsData.startDate.value) <= today && reportsData.startDate.value != "" && reportsData.endDate.value != "" && reportsData.startDate.value > reportsData.endDate.value) {
                const validate = validateInput(reportsData.endDate.value, "reports")
                endDateValid = false
                if (validate.isValid) {
                    toast.error("'To' date must be equal or bigger than 'From' date")
                } else {
                    toast.error("Selected date should be within the last two years")
                }
            } else {
                endDateValid = true
            }
            toast.error(errorMessage.mandatoryFieldsToastErrorMessage);
            setReportsData((prevState) => ({
                ...prevState,
                startDate: {
                    value: reportsData.startDate.value,
                    isValid: reportsData.startDate.value != "" && reportsData.startDate.isValid
                },
                endDate: {
                    value: reportsData.endDate.value,
                    isValid: reportsData.endDate.value != "" && reportsData.endDate.isValid && endDateValid
                },
                program: {
                    value: reportsData.program.value,
                    isValid: reportsData.program.value != "" && reportsData.program.isValid
                }
            }))
        }
    }

    const cancelReports = () => {
        setReportsData({
            startDate: { value: "", isValid: true },
            endDate: { value: "", isValid: true },
            program: { value: "", isValid: true }
        })
        setIsDataAvailable(false)
    }

    const handleGeneratePdf = async () => {
        let doc = (reportsData.program.value == "FAF" || reportsData.program.value == "CASE") ? new jsPDF({
            orientation: "landscape",
            unit: 'px',
            format: [10 * 72, 9 * 72],
        }) : new jsPDF({
            orientation: "landscape",
            unit: 'px',
            format: [15 * 72, 9 * 72],
        })

        let arr = []

        const imageToBase64 = (src) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = "Anonymous";

                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;

                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);

                    // JPEG avoids jsPDF PNG corruption issues
                    resolve(canvas.toDataURL("image/jpeg", 1.0));
                };

                img.onerror = reject;
                img.src = src;
            });
        };

        // let tableHead = reportsData.program.value == "CASE" ? [['Patient Name', 'Primary Point of Contact Name', 'Status', 'Sub-Status']] : (reportsData.program.value == "FAF" ? [['Patient Name', 'Application ID', 'Fund Name', 'Approval Date', 'Expiration Date', 'Award Amount', 'Application Status', 'Reason']] : [['Patient Name', 'Application ID', 'Fund Name', 'Approval Date', 'Expiration Date', 'Revoke Date', 'Lookback Date', 'Grace Period Date', 'Award Amount', 'Guaranteed Account Balance', 'Un-Guaranteed Account Balance', 'Account Balance', 'Application Status', 'Reason']])
        let tableHead;
        if (reportsData.program.value == "FAF") {
            const logoBase64 = await imageToBase64(newLogo)
            tableHead = [['Patient Name', 'Application ID', 'Fund Name', 'Approval Date', 'Expiration Date', 'Award Amount', 'Application Status', 'Reason']]
            doc.addImage(logoBase64, 'PNG', 20, 20, 170, 70)
            doc.text(`Date Range : ${reportsData.startDate.value} - ${reportsData.endDate.value}`, 400, 60); // (text, x, y)
            reportsValue?.map((data) => {
                arr.push([data.PatientFullName, data.ApplicationID, data.DisplayName, data.AppApprovalDateTime, data.AppExpirationDate, data.awardAmount, data.PortalAppStatus, data.PortalAppStatus == "Denied" ? data.AppStatusReason : "--"])
            })
        } else if (reportsData.program.value == "CPR") {
            tableHead = [['Patient Name', 'Application ID', 'Fund Name', 'Approval Date', 'Expiration Date', 'Revoke Date', 'Lookback Date', 'Grace Period Date', 'Award Amount', 'Guaranteed Account Balance', 'Un-Guaranteed Account Balance', 'Account Balance', 'Application Status', 'Reason']]
            const cprLogoBase64 = await imageToBase64(cprLogo);
            doc.addImage(cprLogoBase64, 'PNG', 20, 20, 250, 100)
            doc.text(`Date Range : ${reportsData.startDate.value} - ${reportsData.endDate.value}`, 750, 75); // (text, x, y)
            reportsValue?.map((data) => {
                arr.push([data.PatientFullName, data.ApplicationID, data.DisplayName, data.AppApprovalDateTime, data.AppExpirationDate, data.revokeDate, data.AppLookBackDate, data.appGracePeriod, data.awardAmount, data.guaranteedAmount, data.unGuaranteedAmount, data.patientBalance, data.PortalAppStatus, data.PortalAppStatus == "Denied" ? data.AppStatusReason : "--"])
            })
        } else if (reportsData.program.value == "CASE") {
            const logoBase64 = await imageToBase64(newLogo)
            tableHead = [['Patient Name', 'Primary Point of Contact Name', "Case ID", 'Status', 'Sub-Status']]
            doc.addImage(logoBase64, 'PNG', 20, 20, 170, 70)
            doc.text(`Date Range : ${reportsData.startDate.value} - ${reportsData.endDate.value}`, 400, 60); // (text, x, y)
            reportsValue?.map((data) => {
                arr.push([data.PatientFullName, data.pointOfContactName, data.applicationID, data.PortalAppStatus, data.subStatus])
            })
        } else {
            tableHead = [["Name", "Type", "Program", "ID", "Created Date", "Status"]]
            doc.addImage(fafLogo, 'PNG', 20, 20, 170, 70)
            doc.text(`Date Range : ${reportsData.startDate.value} - ${reportsData.endDate.value}`, 400, 60); // (text, x, y)

            let tableBody = [];
            const rowSpans = []; // track how many rows each name should span

            reportsValue.forEach(person => {
                const rowCount = person.records.length;
                person.records.forEach((record, idx) => {
                    tableBody.push([
                        idx === 0 ? person.name : "", // we will merge later
                        record.type,
                        record.program,
                        record.id,
                        record.createdDate,
                        record.status,
                    ]);
                });
                rowSpans.push(rowCount);
            });

            // const logoBase64 = "data:image/png;base64,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"
            const logoBase64 = await imageToBase64(newLogo)
            tableBody = [[
                { text: "Name", bold: true, color: "#fff", fillColor: "#007BBA", alignment: "center" },
                { text: "Type", bold: true, color: "#fff", fillColor: "#007BBA", alignment: "center" },
                { text: "Program", bold: true, color: "#fff", fillColor: "#007BBA", alignment: "center" },
                { text: "ID", bold: true, color: "#fff", fillColor: "#007BBA", alignment: "center" },
                { text: "Created Date", bold: true, color: "#fff", fillColor: "#007BBA", alignment: "center" },
                { text: "Status", bold: true, color: "#fff", fillColor: "#007BBA", alignment: "center" },
            ]];

            const defaultRowHeight = 20;

            reportsValue.forEach(person => {
                const rowSpan = person.records.length;
                const totalHeight = rowSpan * defaultRowHeight;
                const verticalOffset = totalHeight / 2 - 5;

                person.records.forEach((record, index) => {
                    const row = [
                        index === 0
                            ? {
                                text: person.name,
                                rowSpan,
                                alignment: "center",
                                margin: [0, verticalOffset, 0, 0],
                            }
                            : "",
                        record.type || "",
                        record?.program == "CPR" ? "TA" : record.program || "",
                        record.id || "",
                        record.createdDate,
                        record.status || "",
                    ];
                    tableBody.push(row);
                });
            });

            const docDefinition = {
                content: [
                    {
                        columns: [
                            {
                                image: logoBase64, // logo as base64
                                width: 140,
                            },
                            {
                                text: `Date Range : ${reportsData.startDate.value} - ${reportsData.endDate.value}`,
                                style: "header",
                                alignment: "right",
                                margin: [0, 3, 0, 0]
                            }
                        ]
                    },
                    {
                        table: {
                            headerRows: 1,
                            widths: [120, 80, 60, 150, 90, 90],
                            body: tableBody,
                        },
                        layout: {
                            hLineColor: '#ccc',
                            vLineColor: '#ccc',
                            paddingLeft: () => 8,
                            paddingRight: () => 8,
                            paddingTop: () => 6,
                            paddingBottom: () => 6,
                            fillColor: (rowIndex) => {
                                if (rowIndex === 0) return "#007BBA";
                                // return rowIndex % 2 === 0 ? "#f9f9f9" : null;
                            }
                        },
                        margin: [0, 20, 0, 0] // space below header/logo
                    }
                ],
                styles: {
                    header: { fontSize: 18, bold: true }
                },
                pageOrientation: "landscape"
            };

            // Add some gap before these tables (spacing from previous table)
            docDefinition.content.push({ text: '', margin: [0, 20] }); // 20px gap

            // Add the headings above each table
            docDefinition.content.push({
                columns: [
                    { width: '25%', text: '' },
                    { text: 'Applications', style: 'tableTitle', width: '25%', alignment: 'center', margin: [0, 0, 0, 5] },
                    { text: 'Cases', style: 'tableTitle', width: '25%', alignment: 'center', margin: [0, 0, 0, 5] },
                    { width: '25%', text: '' },
                ]
            });

            // Add the two parallel tables below the headings
            docDefinition.content.push({
                columns: [
                    { width: '25%', text: '' },
                    {
                        width: '25%',
                        table: {
                            headerRows: 1,
                            widths: [100, 40],
                            body: [
                                [
                                    { text: 'Status', style: 'tableHeader', fillColor: '#f0f0f0', alignment: 'center' },
                                    { text: 'Count', style: 'tableHeader', fillColor: '#f0f0f0', alignment: 'center' }
                                ],
                                ['Total Applications', { text: appCount?.totalApplications || 0, alignment: 'center' }],
                                [
                                    { text: '- Denied', alignment: 'left', margin: [10, 0, 0, 0] },
                                    { text: appCount?.denied || 0, alignment: 'center' }
                                ],
                                [
                                    { text: '- Approved', alignment: 'left', margin: [10, 0, 0, 0] },
                                    { text: appCount?.approved || 0, alignment: 'center' }
                                ],
                                [
                                    { text: '- Pending', alignment: 'left', margin: [10, 0, 0, 0] },
                                    { text: appCount?.pending || 0, alignment: 'center' }
                                ]
                            ]
                        },
                        layout: {
                            fillColor: function (rowIndex) {
                                return rowIndex % 2 === 0 ? '#f9f9f9' : null; // alternate row color
                            }
                        }
                    },
                    {
                        width: '25%',
                        table: {
                            headerRows: 1,
                            widths: [100, 40],
                            body: [
                                [
                                    { text: 'Status', style: 'tableHeader', fillColor: '#f0f0f0' },
                                    { text: 'Count', style: 'tableHeader', fillColor: '#f0f0f0' }
                                ],
                                ['Total Cases', { text: appCount?.totalCases || 0, alignment: 'center' }],
                                [
                                    { text: '- New', alignment: 'left', margin: [10, 0, 0, 0] },
                                    { text: appCount?.newCases || 0, alignment: 'center' }
                                ],
                                [
                                    { text: '- In Progress', alignment: 'left', margin: [10, 0, 0, 0] },
                                    { text: appCount?.inProgress || 0, alignment: 'center' }
                                ],
                                [
                                    { text: '- Closed', alignment: 'left', margin: [10, 0, 0, 0] },
                                    { text: appCount?.closedCases || 0, alignment: 'center' }
                                ]
                            ]
                        },
                        layout: {
                            fillColor: function (rowIndex) {
                                return rowIndex % 2 === 0 ? '#f9f9f9' : null; // alternate row color
                            }
                        }
                    },
                    { width: '25%', text: '' },
                ],
                columnGap: 30, // gap between the two tables
            });

            // Add styles for titles and headers
            docDefinition.styles = {
                ...docDefinition.styles,
                tableHeader: {
                    bold: true,
                    fontSize: 12,
                    color: '#333',
                    alignment: 'center'
                },
                tableTitle: {
                    bold: true,
                    fontSize: 14,
                    color: '#000',
                    alignment: 'center'
                }
            };

            // Add centered text after the tables
            docDefinition.content.push({
                text: `Total Patients - ${reportsValue?.length || 0}`,
                style: 'footerText',
                alignment: 'center',
                margin: [0, 20, 0, 0] // add some space above
            });

            // Add style for the footer text
            docDefinition.styles = {
                ...docDefinition.styles,
                footerText: {
                    fontSize: 16,
                    italics: true,
                    color: '#555'
                }
            };

            pdfMake.createPdf(docDefinition).download("Reports.pdf");

            return
        }

        autoTable(doc, {
            head: tableHead,
            body: arr,
            startY: 120,
        })

        doc.save('Reports.pdf')
    };

    const searchReports = (e) => {
        const inputData = e.target.value
        let arr = []
        if (reportsData.program.value == "CPR") {
            reportsValue?.filter((data) => {
                if (data?.PatientFullName?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.ApplicationID?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.DisplayName?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.AppApprovalDateTime?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.AppExpirationDate?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.awardAmount?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.PortalAppStatus?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.revokeDate?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.AppLookBackDate?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.appGracePeriod?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.guaranteedAmount?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.unGuaranteedAmount?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.patientBalance?.toLowerCase()?.includes(inputData?.toLowerCase())) {
                    arr.push(data)
                }
            })
        } else if (reportsData.program.value == "FAF") {
            reportsValue?.filter((data) => {
                if (data?.PatientFullName?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.ApplicationID?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.DisplayName?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.AppApprovalDateTime?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.AppExpirationDate?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.awardAmount?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.PortalAppStatus?.toLowerCase()?.includes(inputData?.toLowerCase())) {
                    arr.push(data)
                }
            })
        } else if (reportsData.program.value == "CASE") {
            reportsValue?.filter((data) => {
                if (data?.PatientFullName?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.pointOfContactName?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.PortalAppStatus?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                    data?.subStatus?.toLowerCase()?.includes(inputData?.toLowerCase())) {
                    arr.push(data)
                }
            })
        } else {
            reportsValue?.filter((person) => {
                if (person.name?.toLowerCase()?.includes(inputData?.toLowerCase())) {
                    // arr.push(person)
                    arr = [...new Set([...arr, person])]
                } else {
                    person?.records?.filter((data) => {
                        if (data?.type?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                            data?.program?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                            data?.status?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                            data?.createdDate?.toLowerCase()?.includes(inputData?.toLowerCase()) ||
                            data?.id?.toLowerCase()?.includes(inputData?.toLowerCase())) {
                            // arr.push(person)
                            arr = [...new Set([...arr, person])]
                        }
                    })
                }
            })
        }
        if (inputData == "") {
            setReportsValue(initialValue)
            setPosts(initialValue)
            setReportsData((prevState) => ({
                ...prevState,
                search: {
                    value: "",
                    isValid: true,
                },
            }))
        } else {
            const data = arr.length > 0 ? arr : ['data']
            setReportsValue(data)
            setPosts(data)
            setReportsData((prevState) => ({
                ...prevState,
                search: {
                    value: inputData,
                    isValid: true,
                },
            }))
        }
    }

    return (
        <React.Fragment>
            {loader ? <Loader /> : null}
            <div className="content">
                <TopBar />
                <div className='bg_white mt-5'>
                    <div className="d-flex justify-content-center pt-5">
                        <div className="px-5 mt-1">
                            <div className="fw-medium text-center fs-xl">GENERATE REPORTS</div>
                        </div>
                    </div>
                    <div className='px-8 mt-5'>
                        <label className='px-5 text-theme-12'>Select Date</label>
                    </div>
                    <div class="modal-body grid columns-12 gap-4 gap-y-2">
                        <div class="g-col-12 g-col-sm-6">
                            <DateInput
                                id="startDate"
                                name="startDate"
                                label={"From"}
                                value={reportsData.startDate.value}
                                isValid={reportsData.startDate.isValid}
                                errorMsg={errorMessage.inputErrorMessage}
                                onChange={(e) => inputOnChange(e, 'reports')}
                                user="reports"
                            />
                        </div>
                        <div class="g-col-12 g-col-sm-6">
                            <DateInput
                                id="endDate"
                                name="endDate"
                                label={"To"}
                                value={reportsData.endDate.value}
                                isValid={reportsData.endDate.isValid}
                                errorMsg={errorMessage.inputErrorMessage}
                                onChange={(e) => inputOnChange(e, 'reports')}
                                user="reports"
                            />
                        </div>
                    </div>
                    <div class="px-8 py-8">
                        <label className='px-5 text-theme-12'>Select Program</label>
                        <div class="modal-body grid columns-12 gap-4 gap-y-2">
                            <div class="g-col-12 g-col-sm-6"><input id="radio-switch-4" class="form-check-input" type="radio" name="program" value="CPR" checked={reportsData.program.value == "CPR"} onChange={(e) => inputOnChange(e, 'dropDown')} />
                                <label class="form-check-label" for="radio-switch-4" >Summary of Application Activity for TotalAssist program</label></div>
                            <div class="g-col-12 g-col-sm-6"><input id="radio-switch-5" class="form-check-input" type="radio" name="program" value="FAF" checked={reportsData.program.value == "FAF"} onChange={(e) => inputOnChange(e, 'dropDown')} />
                                <label class="form-check-label" for="radio-switch-5">Summary of Application Activity for FAF</label></div>
                            <div class="g-col-12 g-col-sm-6"><input id="radio-switch-5" class="form-check-input" type="radio" name="program" value="CASE" checked={reportsData.program.value == "CASE"} onChange={(e) => inputOnChange(e, 'dropDown')} />
                                <label class="form-check-label" for="radio-switch-5">Summary of Case Activity for Case Management</label></div>
                            <div class="g-col-12 g-col-sm-6"><input id="radio-switch-5" class="form-check-input" type="radio" name="program" value="ALL" checked={reportsData.program.value == "ALL"} onChange={(e) => inputOnChange(e, 'dropDown')} />
                                <label class="form-check-label" for="radio-switch-5">Summary of TotalAssist, FAF and Case Management Reports</label></div>
                        </div>
                        {!reportsData.program.isValid && <span className='mt-5 px-5 fs-s color-danger'>Please Select Program</span>}
                    </div>
                    <div
                        className={`pt-8 pb-8 d-flex justify-content-center gap-6 mb-10 ${style.bottom_button} `}
                    >
                        <button
                            onClick={cancelReports}
                            className={`btn ${style.buttons_register}`}
                        >
                            Cancel
                        </button>
                        <button
                            onClick={getReports}
                            type="submit"
                            className={`btn ${style.buttons}`}
                        >
                            Get Reports
                        </button>
                    </div>
                    <div class="px-8 py-8">
                        <p><b>Please note that the data included in reports is not provided in real time.  It is delayed by one day and will not include any data or activity from the current day.</b></p>
                    </div>
                </div>
                {isDataAvailable &&
                    (posts.length > 0 ?
                        <React.Fragment>
                            <div className='intro-y box mt-5 p-5 text-end color-primary text-decoration-underline'><Link onClick={handleGeneratePdf}>Download Reports</Link></div>
                            <div className="grid columns-12 gap-4 gap-y-5 p-3 pb-5 ntro-y box">
                                <Input
                                    type="text"
                                    id="search"
                                    label="Search..."
                                    name="search"
                                    isValid={true}
                                    onChange={(e) => searchReports(e)}
                                    maxLength="100"
                                    value={reportsData.search.value}
                                />
                            </div>
                            {(reportsData.program.value == "CASE" && currentPosts.length > 0) && (posts[0] == "data" ? <div className='intro-y box p-8 mt-5'>No cases found!</div> : <>
                                <div className="intro-y box mt-5">
                                    <div className='fw-medium text-center fs-xl p-5'>CASE Reports</div>
                                    <div id="basic-table">
                                        <div className="preview">
                                            <div className="overflow-x-auto">
                                                <table className="table">
                                                    <thead className='p-5'>
                                                        <tr className='text-center'>
                                                            <th className="text-nowrap"></th>
                                                            <th className="text-nowrap">Patient Name</th>
                                                            <th className="text-nowrap">Primary Point of Contact Name</th>
                                                            <th className="text-nowrap">Case ID</th>
                                                            <th className="text-nowrap">Status</th>
                                                            <th className="text-nowrap">Sub-Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody >
                                                        {currentPosts?.map((data) => {
                                                            if (data.program == "CASE") {
                                                                return <tr className='text-center'>
                                                                    <td>{data.PatientFullName}</td>
                                                                    <td>{data.PatientFullName}</td>
                                                                    <td>{data.pointOfContactName}</td>
                                                                    <td>{data.applicationID}</td>
                                                                    <td><span className={`py-1 px-5 g-col-5 text-center rounded-pill fs-xs text-white cursor-pointer fw-medium text-center ${data?.PortalAppStatus == 'Closed' ? `bg-theme-6` : data?.PortalAppStatus == 'Pending' ? `bg-yellow` : (data?.PortalAppStatus == 'Approved' || data?.PortalAppStatus == 'In Progress' || data?.PortalAppStatus == 'InProgress' || data?.PortalAppStatus == 'Attempted') ? `bg-theme-9` : `bg-default`}`}>
                                                                        {data.PortalAppStatus}
                                                                    </span></td>
                                                                    <td>{data.subStatus}</td>
                                                                </tr>
                                                            }
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center mb-5 pt-6">
                                    <ReactPaginate
                                        nextLabel=">"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={3}
                                        marginPagesDisplayed={2}
                                        pageCount={Math.ceil(posts.length / postsPerPage)}
                                        previousLabel="<"
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        breakLabel="..."
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        containerClassName="pagination"
                                        activeClassName="active"
                                        renderOnZeroPageCount={null}
                                    />
                                    <br />
                                </div></>)}
                            {(reportsData.program.value == "FAF" && currentPosts.length > 0) && (posts[0] == "data" ? <div className='intro-y box p-8 mt-5'>No applications found!</div> : <>
                                <div className="intro-y box mt-5">
                                    <div className='fw-medium text-center fs-xl p-5'>FAF Reports</div>
                                    <div id="basic-table">
                                        <div className="preview">
                                            <div className="overflow-x-auto">
                                                <table className="table">
                                                    <thead className='p-5'>
                                                        <tr>
                                                            <th className="text-nowrap"></th>
                                                            <th className="text-nowrap">Patient Name</th>
                                                            <th className="text-nowrap">Application ID</th>
                                                            <th className="text-center">Fund Name</th>
                                                            <th className="text-nowrap">Approval Date</th>
                                                            <th className="text-nowrap">Expiration Date</th>
                                                            <th className="text-nowrap">Award Amount</th>
                                                            <th className="text-nowrap">Application Status</th>
                                                            <th className="text-nowrap">Reason</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody >
                                                        {currentPosts?.map((data) => {
                                                            if (data.program == "FAF") {
                                                                return <tr className='text-center'>
                                                                    <td>{data.PatientFullName}</td>
                                                                    <td>{data.PatientFullName}</td>
                                                                    <td>{data.ApplicationID}</td>
                                                                    <td>{data.DisplayName}</td>
                                                                    <td>{data.AppApprovalDateTime}</td>
                                                                    <td>{data.AppExpirationDate}</td>
                                                                    <td>{data.awardAmount}</td>
                                                                    <td><span className={`py-1 px-5 g-col-5 text-center rounded-pill fs-xs text-white cursor-pointer fw-medium text-center ${data.PortalAppStatus == 'Denied' ? `bg-theme-6` : data.PortalAppStatus == 'Pending' ? `bg-yellow` : (data.PortalAppStatus == 'Approved' || data.PortalAppStatus == 'Paid') ? `bg-theme-9` : `bg-default`}`}>
                                                                        {data.PortalAppStatus}
                                                                    </span></td>
                                                                    <td>{data.PortalAppStatus == "Denied" ? data.AppStatusReason : "--"}</td>
                                                                </tr>
                                                            }
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center mb-5 pt-6">
                                    <ReactPaginate
                                        nextLabel=">"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={3}
                                        marginPagesDisplayed={2}
                                        pageCount={Math.ceil(posts.length / postsPerPage)}
                                        previousLabel="<"
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        breakLabel="..."
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        containerClassName="pagination"
                                        activeClassName="active"
                                        renderOnZeroPageCount={null}
                                    />
                                    <br />
                                </div></>)}
                            {(reportsData.program.value == "CPR" && currentPosts.length > 0) && (posts[0] == "data" ? <div className='intro-y box p-8 mt-5'>No applications found!</div> : <>
                                <div className="intro-y box mt-5">
                                    <div className='fw-medium text-center fs-xl p-5'>TotalAssist Reports</div>
                                    <div id="basic-table">
                                        <div className="preview">
                                            <div className="overflow-x-auto">
                                                <table className="table">
                                                    <thead className='p-5'>
                                                        <tr>
                                                            <th className="text-nowrap"></th>
                                                            <th className="text-nowrap">Patient Name</th>
                                                            <th className="text-nowrap">Application ID</th>
                                                            <th className="text-nowrap">Fund Name</th>
                                                            <th className="text-nowrap">Approval Date</th>
                                                            <th className="text-nowrap">Expiration Date</th>
                                                            <th className="text-nowrap">Revoke Date</th>
                                                            <th className="text-nowrap">Lookback Date</th>
                                                            <th className="text-nowrap">Grace Period Date</th>
                                                            <th className="text-nowrap">Award Amount</th>
                                                            <th className="text-nowrap">Guaranteed Account Balance</th>
                                                            <th className="text-nowrap">Un-Guaranteed Account Balance</th>
                                                            <th className="text-nowrap">Account Balance</th>
                                                            <th className="text-nowrap">Application Status</th>
                                                            <th className="text-nowrap">Reason</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody >
                                                        {currentPosts?.map((data) => {
                                                            if (data.program == "CPR") {
                                                                return <tr className='text-center'>
                                                                    <td>{data.PatientFullName}</td>
                                                                    <td>{data.PatientFullName}</td>
                                                                    <td>{data.ApplicationID}</td>
                                                                    <td>{data.DisplayName}</td>
                                                                    <td>{data.AppApprovalDateTime}</td>
                                                                    <td>{data.AppExpirationDate}</td>
                                                                    <td>{data.revokeDate}</td>
                                                                    <td>{data.AppLookBackDate}</td>
                                                                    <td>{data.appGracePeriod}</td>
                                                                    <td>{data.awardAmount}</td>
                                                                    <td>{data.guaranteedAmount}</td>
                                                                    <td>{data.unGuaranteedAmount}</td>
                                                                    <td>{data.patientBalance}</td>
                                                                    <td><span className={`py-1 px-5 g-col-5 text-center rounded-pill fs-xs text-white cursor-pointer fw-medium text-center ${data.PortalAppStatus == 'Denied' ? `bg-theme-6` : data.PortalAppStatus == 'Pending' ? `bg-yellow` : (data.PortalAppStatus == 'Approved' || data.PortalAppStatus == 'Paid') ? `bg-theme-9` : `bg-default`}`}>
                                                                        {data.PortalAppStatus}
                                                                    </span></td>
                                                                    <td>{data.PortalAppStatus == "Denied" ? data.AppStatusReason : "--"}</td>
                                                                </tr>
                                                            }
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center mb-5 pt-6">
                                    <ReactPaginate
                                        nextLabel=">"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={3}
                                        marginPagesDisplayed={2}
                                        pageCount={Math.ceil(posts.length / postsPerPage)}
                                        previousLabel="<"
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        breakLabel="..."
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        containerClassName="pagination"
                                        activeClassName="active"
                                        renderOnZeroPageCount={null}
                                    />
                                    <br />
                                </div></>)}
                            {(reportsData.program.value == "ALL" && currentPosts.length > 0) && (posts[0] == "data" ? <div className='intro-y box p-8 mt-5'>No cases found!</div> : <>
                                <div className="intro-y box mt-5 p-8">
                                    <div id="basic-table">
                                        <div className="preview">
                                            <div className="overflow-x-auto">
                                                <table className="table">
                                                    <thead className='p-5'>
                                                        <tr className='text-center'>
                                                            <th className="text-nowrap"></th>
                                                            <th className="border border-gray-400 p-2 text-left">Name</th>
                                                            <th className="border border-gray-400 p-2 text-left">Type</th>
                                                            <th className="border border-gray-400 p-2 text-left">Program</th>
                                                            <th className="border border-gray-400 p-2 text-left">ID</th>
                                                            <th className="border border-gray-400 p-2 text-left">Created Date</th>
                                                            <th className="border border-gray-400 p-2 text-left">Status</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody >
                                                        {currentPosts?.map((person, idx) => {
                                                            return person?.records?.map((record, rIdx) => (
                                                                <tr key={`${idx}-${rIdx}`}>
                                                                    {rIdx === 0 && (
                                                                        <>
                                                                            <td
                                                                                rowSpan={person.records.length}
                                                                                className="border border-gray-400 p-2 align-top font-semibold"
                                                                            >
                                                                                {person.name}
                                                                            </td>
                                                                            <td
                                                                                rowSpan={person.records.length}
                                                                                className="border border-gray-400 p-2 align-top font-semibold"
                                                                            >
                                                                                {person.name}
                                                                            </td>
                                                                        </>
                                                                    )}
                                                                    <td className="border border-gray-400 p-2" style={{ display: "table-cell" }}>{record.type}</td>
                                                                    <td className="border border-gray-400 p-2">{record?.program == "CPR" ? "TA" : record.program }</td>
                                                                    <td className="border border-gray-400 p-2">{record.id}</td>
                                                                    <td className="border border-gray-400 p-2">{record.createdDate}</td>
                                                                    <td className="border border-gray-400 p-2"><span className={`py-1 px-5 g-col-5 text-center rounded-pill fs-xs text-white cursor-pointer fw-medium text-center ${(record?.status == 'Denied' || (record?.program == "CM" && record?.status == 'Closed')) ? `bg-theme-6` : record?.status == 'Pending' ? `bg-yellow` : (record?.status == 'Approved' || record?.status == 'In Progress' || record?.status == 'InProgress' || record?.status == 'Attempted') ? `bg-theme-9` : `bg-default`}`}>
                                                                        {record.status}
                                                                    </span></td>
                                                                </tr>
                                                            ));
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center mb-5 pt-6">
                                    <ReactPaginate
                                        nextLabel=">"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={3}
                                        marginPagesDisplayed={2}
                                        pageCount={Math.ceil(posts.length / postsPerPage)}
                                        previousLabel="<"
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        breakLabel="..."
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        containerClassName="pagination"
                                        activeClassName="active"
                                        renderOnZeroPageCount={null}
                                    />
                                    <br />
                                </div></>)}
                        </React.Fragment> :
                        <div className='intro-y box p-8 mt-5'>No applications or cases found!</div>)
                }
            </div>
        </React.Fragment>
    )
}

export default Reports